// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GrowthProfilesSummaryPanel_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, skipCurrentYearGrowth: boolean, isTwoGrantor: boolean, kind?: Types.EstateWaterfallKind | null, growthProfile?: { __typename?: 'GrowthProfile', id: string, assetGrowthReturn?: Percent | null, exemptionGrowthRate: Percent } | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, visualizationWithProjections: { __typename?: 'EstateWaterfallViz', _cacheKey: string, firstDeathTaxSummaryV2: (
      { __typename?: 'TaxSummaryV2' }
      & GrowthProfilesSummaryPanel_TaxSummaryV2Fragment
    ), secondDeathTaxSummaryV2?: (
      { __typename?: 'TaxSummaryV2' }
      & GrowthProfilesSummaryPanel_TaxSummaryV2Fragment
    ) | null } };

export type GrowthProfilesSummaryPanel_StateTaxDetailFragment = { __typename?: 'StateTaxDetail', stateCode?: Types.StateCode | null, stateDisclosure?: string | null, _cacheKey: string };

export type GrowthProfilesSummaryPanel_TaxSummaryV2Fragment = { __typename?: 'TaxSummaryV2', _cacheKey: string, stateTax?: Array<(
    { __typename?: 'StateTaxDetail' }
    & GrowthProfilesSummaryPanel_StateTaxDetailFragment
  )> | null };

export type UpdateEstateWaterfallGrowthProfileMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type UpdateEstateWaterfallGrowthProfileMutation = { __typename?: 'Mutation', updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export const Operations = {
  Mutation: {
    UpdateEstateWaterfallGrowthProfile: 'UpdateEstateWaterfallGrowthProfile' as const
  },
  Fragment: {
    GrowthProfilesSummaryPanel_EstateWaterfall: 'GrowthProfilesSummaryPanel_EstateWaterfall' as const,
    GrowthProfilesSummaryPanel_StateTaxDetail: 'GrowthProfilesSummaryPanel_StateTaxDetail' as const,
    GrowthProfilesSummaryPanel_TaxSummaryV2: 'GrowthProfilesSummaryPanel_TaxSummaryV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GrowthProfilesSummaryPanel_StateTaxDetailFragmentDoc = gql`
    fragment GrowthProfilesSummaryPanel_StateTaxDetail on StateTaxDetail {
  stateCode
  stateDisclosure
  _cacheKey
}
    `;
export const GrowthProfilesSummaryPanel_TaxSummaryV2FragmentDoc = gql`
    fragment GrowthProfilesSummaryPanel_TaxSummaryV2 on TaxSummaryV2 {
  stateTax {
    ...GrowthProfilesSummaryPanel_StateTaxDetail
  }
  _cacheKey
}
    ${GrowthProfilesSummaryPanel_StateTaxDetailFragmentDoc}`;
export const GrowthProfilesSummaryPanel_EstateWaterfallFragmentDoc = gql`
    fragment GrowthProfilesSummaryPanel_EstateWaterfall on EstateWaterfall {
  id
  displayName
  firstGrantorDeathYear
  secondGrantorDeathYear
  skipCurrentYearGrowth
  growthProfile {
    id
    assetGrowthReturn
    exemptionGrowthRate
  }
  isTwoGrantor
  firstGrantorDeath {
    id
  }
  kind
  visualizationWithProjections {
    _cacheKey
    firstDeathTaxSummaryV2 {
      ...GrowthProfilesSummaryPanel_TaxSummaryV2
    }
    secondDeathTaxSummaryV2 {
      ...GrowthProfilesSummaryPanel_TaxSummaryV2
    }
  }
}
    ${GrowthProfilesSummaryPanel_TaxSummaryV2FragmentDoc}`;
export const UpdateEstateWaterfallGrowthProfileDocument = gql`
    mutation UpdateEstateWaterfallGrowthProfile($input: AugmentedUpdateEstateWaterfallInput!) {
  updateEstateWaterfall(input: $input) {
    id
  }
}
    `;
export type UpdateEstateWaterfallGrowthProfileMutationFn = Apollo.MutationFunction<UpdateEstateWaterfallGrowthProfileMutation, UpdateEstateWaterfallGrowthProfileMutationVariables>;

/**
 * __useUpdateEstateWaterfallGrowthProfileMutation__
 *
 * To run a mutation, you first call `useUpdateEstateWaterfallGrowthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateWaterfallGrowthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateWaterfallGrowthProfileMutation, { data, loading, error }] = useUpdateEstateWaterfallGrowthProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEstateWaterfallGrowthProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateWaterfallGrowthProfileMutation, UpdateEstateWaterfallGrowthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateWaterfallGrowthProfileMutation, UpdateEstateWaterfallGrowthProfileMutationVariables>(UpdateEstateWaterfallGrowthProfileDocument, options);
      }
export type UpdateEstateWaterfallGrowthProfileMutationHookResult = ReturnType<typeof useUpdateEstateWaterfallGrowthProfileMutation>;
export type UpdateEstateWaterfallGrowthProfileMutationResult = Apollo.MutationResult<UpdateEstateWaterfallGrowthProfileMutation>;
export type UpdateEstateWaterfallGrowthProfileMutationOptions = Apollo.BaseMutationOptions<UpdateEstateWaterfallGrowthProfileMutation, UpdateEstateWaterfallGrowthProfileMutationVariables>;